import apiClient from "./client";
export const getProfile = async () => (await apiClient.get("/profile")).data.profile;
export const updateProfile = async (payload) => (await apiClient.patch("/profile", payload)).data.profile;
